/**
 * @desc 新增多订单退货
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AsMaterialRejectBillMultipleRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/createMultipleOrders`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
